import {
    LOGIN_USER_SUCCESS,
    LOGIN_USER_FAILED,
    LOGIN_USER,
    LOGOUT_USER,
} from '../actions/types';

import {AsyncStorage} from 'react-native-web';
import {stringIsEmpty} from "../../constants/StringChecker";

const INITIAL_STATE = {
    errorMessage: '',              //Error when the autentication fail
    isFetching: false,         //Autentication request is waiting.
    isSuccess: false,
    authData: {},
    emailPersist: '',
    passwordPersist: '',
};

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOGOUT_USER:
            AsyncStorage.setItem('user_email', '');
            AsyncStorage.setItem('user_password', '');
            return INITIAL_STATE;

        case LOGIN_USER:
            return {
                ...state,
                isFetching: true,
                isSuccess: false,
                errorMessage: ''
            };

        case LOGIN_USER_SUCCESS:
            AsyncStorage.setItem('user_email', action.payload.userId);
            if (!stringIsEmpty(action.payload.password)) {
                AsyncStorage.setItem('user_password', action.payload.password);
            }

            return {
                ...state,
                isSuccess: true,
                isFetching: false,
                authData: action.payload.authData,
            };

        case LOGIN_USER_FAILED:
            return {
                ...state,
                errorMessage: action.payload,
                isFetching: false
            };

        default:
            return state;
    }
}
